import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { Colors } from "~/config/Colors";

import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import { Label, Input, Select, TextArea } from "~/componentes/CustomForm";

import { Container, Quadro } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";

function CustomBodyContent({ idAnalista, idCliente, setIdAnalista, atualizaMapa, setAtualizaMapa, anoReferencia, setAnoReferencia }) {
  const [diaProjeto, setDiaProjeto]   = useState();

  let dataAtual = new Date();
  let primeiro = dataAtual.getDate() - dataAtual.getDay(); 

  const [primeiroDia, setPrimeiroDia] = useState(new Date(dataAtual.setDate(primeiro)).toUTCString());
  const [ultimoDia, setUltimoDia]     = useState(new Date(dataAtual.setDate(dataAtual.getDate()+6)).toUTCString());

  const [datas, setDatas]       = useState([]);
  const [projetos, setProjetos] = useState([]);

  const month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

  useEffect(() => {
    let dataIncrement = new Date(primeiroDia);
    let dataFinal = new Date(ultimoDia);
    let timeDiff = Math.abs(dataFinal.getTime() - dataIncrement.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; 

    let lista = [];
    for (let count = 0; count < diffDays; count++) {
      let diaMA = dataIncrement.getDate() > 9 ? "" + dataIncrement.getDate() : "0" + dataIncrement.getDate();
      let diaSemana = dataIncrement.getDay();
      let descSemana = "";

      if (diaSemana == 0) {
        descSemana = "DOM";
      } else if (diaSemana == 1) {
        descSemana = "SEG";
      } else if (diaSemana == 2) {
        descSemana = "TER";
      } else if (diaSemana == 3) {
        descSemana = "QUA";
      } else if (diaSemana == 4) {
        descSemana = "QUI";
      } else if (diaSemana == 5) {
        descSemana = "SEX";
      } else if (diaSemana == 6) {
        descSemana = "SAB";
      }

      lista.push({ dia: diaMA, diaSemana, descSemana });
      dataIncrement.setDate(dataIncrement.getDate() + 1);
    }

    setDatas(lista);
    // api.get("/signed/empresa/gestorprojeto/gerencia/analistas", { params: { ativo: 1 } }).then((r) => setAnalistas(r?.data));
  }, [primeiroDia, ultimoDia]);

  useEffect(() => {
    if (idAnalista && atualizaMapa) {
      idAnalista && api.get("/signed/empresa/gestorprojeto/mapalocacao/projetos", { params: { idAnalista, idCliente, anoReferencia, diaInicial: primeiroDia, diaFinal: ultimoDia } }).then((r) => {
        setProjetos(r?.data);
      });
      setAtualizaMapa(false);
    } else {
      setProjetos([]);
    }
  }, [idAnalista, idCliente, atualizaMapa, primeiroDia, ultimoDia]);

  async function handleSubmit(options) {
    const { closeReload } = options || {};

    if (diaProjeto?.itemData?.id) {
      const response = await api.put("/signed/empresa/gestorprojeto/mapalocacao", {
        idAnalista,
        anoReferencia,
        ...diaProjeto?.itemData,
      });
      if (response?.status === 200) {
        closeReload && closeReload();
        // setAtualizaMapa(true);
        
        setProjetos((prev) => {
          let newPrev = [...prev];
          
          let itensProjetos = [];
          let index1 = 0;
          for (const item of newPrev[diaProjeto?.index].projetos) {
            let datas = [];
            let index2 = 0;

            if (index1 == diaProjeto?.indexProjeto) {
              for (const itemData of item?.datas) {
                if (index2 == diaProjeto?.indexData) {
                  datas.push({
                    ...diaProjeto?.itemData,
                    id: response?.data?.id,
                  });
                } else {
                  datas.push(itemData);
                }

                index2++;
              }

              itensProjetos.push({
                ...item,
                datas,
              });
            } else {
              itensProjetos.push(item);
            }

            index1++;
          }
          newPrev[diaProjeto?.index].projetos = itensProjetos;

          return newPrev;
        });

        setDiaProjeto(undefined);
      }

      return response;
    } else {
      const response = await api.post("/signed/empresa/gestorprojeto/mapalocacao", {
        idAnalista,
        anoReferencia,
        ...diaProjeto?.itemData,
      });
      if (response?.status === 200) {
        closeReload && closeReload();
        // setAtualizaMapa(true);

        setProjetos((prev) => {
          let newPrev = [...prev];
          
          let itensProjetos = [];
          let index1 = 0;
          for (const item of newPrev[diaProjeto?.index].projetos) {
            let datas = [];
            let index2 = 0;

            if (index1 == diaProjeto?.indexProjeto) {
              for (const itemData of item?.datas) {
                if (index2 == diaProjeto?.indexData) {
                  datas.push({
                    ...diaProjeto?.itemData,
                    id: response?.data?.id,
                  });
                } else {
                  datas.push(itemData);
                }

                index2++;
              }

              itensProjetos.push({
                ...item,
                datas,
              });
            } else {
              itensProjetos.push(item);
            }

            index1++;
          }
          newPrev[diaProjeto?.index].projetos = itensProjetos;

          return newPrev;
        });

        setDiaProjeto(undefined);
      }

      return response;
    }
  }

  async function handleDelSubmit(options) {
    const { closeReload } = options || {};

    if (diaProjeto?.itemData?.id) {
      const response = await api.delete("/signed/empresa/gestorprojeto/mapalocacao", {
        data: { id: diaProjeto?.itemData?.id, }
      });
      if (response?.status === 200) {
        closeReload && closeReload();
        // setAtualizaMapa(true);
        
        setProjetos((prev) => {
          let newPrev = [...prev];
          
          let itensProjetos = [];
          let index1 = 0;
          for (const item of newPrev[diaProjeto?.index].projetos) {
            let datas = [];
            let index2 = 0;

            if (index1 == diaProjeto?.indexProjeto) {
              for (const itemData of item?.datas) {
                if (index2 == diaProjeto?.indexData) {
                  datas.push({
                    ...diaProjeto?.itemData,
                    id: undefined,
                  });
                } else {
                  datas.push(itemData);
                }

                index2++;
              }

              itensProjetos.push({
                ...item,
                datas,
              });
            } else {
              itensProjetos.push(item);
            }

            index1++;
          }
          newPrev[diaProjeto?.index].projetos = itensProjetos;

          return newPrev;
        });

        setDiaProjeto(undefined);
      }

      return response;
    } else {
      const response = await api.delete("/signed/empresa/gestorprojeto/mapalocacao", {
        data: { id: diaProjeto?.itemData?.id, }
      });
      if (response?.status === 200) {
        closeReload && closeReload();
        // setAtualizaMapa(true);

        setProjetos((prev) => {
          let newPrev = [...prev];
          
          let itensProjetos = [];
          let index1 = 0;
          for (const item of newPrev[diaProjeto?.index].projetos) {
            let datas = [];
            let index2 = 0;

            if (index1 == diaProjeto?.indexProjeto) {
              for (const itemData of item?.datas) {
                if (index2 == diaProjeto?.indexData) {
                  datas.push({
                    ...diaProjeto?.itemData,
                    id: response?.data?.id,
                  });
                } else {
                  datas.push(itemData);
                }

                index2++;
              }

              itensProjetos.push({
                ...item,
                datas,
              });
            } else {
              itensProjetos.push(item);
            }

            index1++;
          }
          newPrev[diaProjeto?.index].projetos = itensProjetos;

          return newPrev;
        });

        setDiaProjeto(undefined);
      }

      return response;
    }
  }

  return (
    <Container>
      <Materialize className="materialize">
        <div className="row no-margin mt-fd">
          <div className="col s12 m12 l12 no-padding">
            <Quadro>
              <div className="header">
                <div className="div-direita">
                  <div className="w3">
                    <p className="title">Projeto</p>
                  </div>
                  <div className="w3">
                    <p className="title">Atividade</p>
                  </div>
                  <div className="w3">
                    <p className="title">Tarefa</p>
                  </div>
                </div>
                <div className="div-esquerda">
                  <div className="top">
                    <div className="movimento">
                      <i 
                        className="material-icons"
                        onClick={() => {
                          let dataPrimeiro = new Date(primeiroDia);
                          let dataUltimo = new Date(ultimoDia);

                          dataUltimo.setDate(dataUltimo?.getDate() - 7);
                          dataPrimeiro.setDate(dataUltimo?.getDate() - 6);

                          setPrimeiroDia(dataPrimeiro.toUTCString());
                          setUltimoDia(dataUltimo.toUTCString());
                          setAtualizaMapa(true);
                        }}
                      >
                        arrow_back_ios
                      </i>
                      <i 
                        className="material-icons"
                        onClick={() => {
                          let dataPrimeiro = new Date(primeiroDia);
                          let dataUltimo = new Date(ultimoDia);

                          dataPrimeiro.setDate(dataPrimeiro?.getDate() + 7);
                          dataUltimo.setDate(dataPrimeiro?.getDate() + 6);

                          setPrimeiroDia(dataPrimeiro.toUTCString());
                          setUltimoDia(dataUltimo.toUTCString());
                          setAtualizaMapa(true);
                        }}
                      >
                        arrow_forward_ios
                      </i>
                    </div>
                    <p className="title">
                      {new Date(primeiroDia).getDate() > 9 ? new Date(primeiroDia).getDate() : "0" + new Date(primeiroDia).getDate()} - 
                      {new Date(ultimoDia).getDate() > 9 ? new Date(ultimoDia).getDate() : "0" + new Date(ultimoDia).getDate()} de {month[new Date(primeiroDia).getMonth()]} de {new Date(primeiroDia).getFullYear()}
                    </p>
                  </div>
                  <div className="bottom">
                    {datas?.map((itemData) => (
                      <div className="w7">
                        <p className="title-dia">{itemData?.dia} {itemData?.descSemana}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="list-aloca">
                {projetos && projetos?.map((itemData, index) => (
                  <div className="item-cliente">
                    <div className="item-body-cli">
                      <div className="div-direita">
                        <div className="w9">
                          <p className="title">{itemData?.titulo}</p>
                        </div>
                        <div className="w1">
                          <div 
                            className="img"
                            onClick={() => {
                              setProjetos((prev) => {
                                let newPrev = [...prev];
          
                                newPrev[index].aberto = !newPrev[index].aberto;
          
                                return newPrev;
                              });
                            }}
                          >
                            {itemData?.aberto == false ? <i className="material-icons">add</i> : <i className="material-icons">remove</i>}
                          </div>
                        </div>
                      </div>
                      <div className="div-esquerda">
                        <div className="bottom"></div>
                      </div>
                    </div>
                    {itemData?.aberto && itemData?.projetos?.map((itemProjeto, indexProjeto) => (
                      <div className="item-projeto">
                        <div className={"item-body-proj " + (indexProjeto % 2 == 0 ? "proj2" : "proj1")}>
                          <div className="div-direita">
                            <div className="w3">
                              <p className="title">{itemProjeto?.tituloProjeto}</p>
                            </div>
                            <div className="w3">
                              <p className="title">{itemProjeto?.tituloAtividade}</p>
                            </div>
                            <div className="w3">
                              <p className="title">{itemProjeto?.tituloTarefa}</p>
                            </div>
                          </div>
                          <div className="div-esquerda">
                            <div className="bottom">
                              {itemProjeto?.datas?.map((itemData, indexData) => (
                                <div 
                                  className="w7" 
                                  onClick={() => {
                                    setDiaProjeto({itemData, index, indexProjeto, indexData});
                                  }}
                                >
                                  {itemData?.id && (
                                    <div className={"item-card " + (itemData?.tipo == "DEV" || itemData?.tipo == "IMP" ? "item-card-azul" : itemData?.tipo == "ATD" ? "item-card-verde" : itemData?.tipo == "REU" ? "item-card-amarelo" : "")}>
                                    <div className="item-card-top">
                                      <p className="title-tipo">{itemData?.tipo}</p>
                                      <p className="title-total">{itemData?.horasDisponiveis}h</p>
                                    </div>
                                    <div className="item-card-bottom">
                                      <p className="title-horario">I: {itemData?.horaInicial} - F: {itemData?.horaFinal}</p>
                                    </div>
                                  </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </Quadro>
          </div>
        </div>
        {diaProjeto && (
          <div className="modal-add">
            <div className="modal-fundo">
              <div className="header-modal">
                <div className="titulo">
                  <p>{diaProjeto?.itemData?.id ? "Alterar" : "Adicionar"} uma Alocação</p>
                </div>
              </div>
              <div className="body-modal">
                <Materialize className="materialize">
                  <div className="row no-margin">
                    <Label title="Projeto *" className="col s6 m4 l4">
                      <Input 
                        name="tituloProjeto" 
                        required="true" 
                        value={diaProjeto?.itemData?.tituloProjeto}
                        disabled={true}
                      />
                    </Label>
                    <Label title="Atividade *" className="col s6 m4 l4">
                      <Input 
                        name="tituloAtividade" 
                        required="true" 
                        value={diaProjeto?.itemData?.tituloAtividade}
                        disabled={true}
                      />
                    </Label>
                    <Label title="Tarefa *" className="col s6 m4 l4">
                      <Input 
                        name="tituloTarefa" 
                        required="true" 
                        value={diaProjeto?.itemData?.tituloTarefa}
                        disabled={true}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Tipo *" className="col s6 m2 l2">
                      <Select
                        isString
                        list={{
                          list: [
                            { id: 'DEV', titulo: 'Desenvolvimento' },
                            { id: 'IMP', titulo: 'Implantação' },
                            { id: 'REU', titulo: 'Reunião' },
                            { id: 'ATD', titulo: 'Atendimento' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        firstOption="Selecione um tipo"
                        name={"tipoAt"}
                        value={diaProjeto?.itemData?.tipo}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "DEV";
      
                          let newPrev = JSON.parse(JSON.stringify(diaProjeto));
                          newPrev.itemData.tipo = v;
      
                          setDiaProjeto(newPrev);
                        }}
                      />
                    </Label>
                    <Label title="Horas Disponíveis *" className="col s6 m2 l2">
                      <Input
                        type="number"
                        name="horasDisponiveisAt"
                        min="1"
                        value={diaProjeto?.itemData?.horasDisponiveis}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;

                          let newPrev = JSON.parse(JSON.stringify(diaProjeto));
                          newPrev.itemData.horasDisponiveis = v;
      
                          setDiaProjeto(newPrev);
                        }}
                      />
                    </Label>
                    <Label title="Hora Inicial" className="col s6 m2 l2">
                      <Select
                        isString
                        list={{
                          list: [
                            { id: '00:00', titulo: '00:00' },
                            { id: '00:15', titulo: '00:15' },
                            { id: '00:30', titulo: '00:30' },
                            { id: '00:45', titulo: '00:45' },
                            { id: '01:00', titulo: '01:00' },
                            { id: '01:15', titulo: '01:15' },
                            { id: '01:30', titulo: '01:30' },
                            { id: '01:45', titulo: '01:45' },
                            { id: '02:00', titulo: '02:00' },
                            { id: '02:15', titulo: '02:15' },
                            { id: '02:30', titulo: '02:30' },
                            { id: '02:45', titulo: '02:45' },
                            { id: '03:00', titulo: '03:00' },
                            { id: '03:15', titulo: '03:15' },
                            { id: '03:30', titulo: '03:30' },
                            { id: '03:45', titulo: '03:45' },
                            { id: '04:00', titulo: '04:00' },
                            { id: '04:15', titulo: '04:15' },
                            { id: '04:30', titulo: '04:30' },
                            { id: '04:45', titulo: '04:45' },
                            { id: '05:00', titulo: '05:00' },
                            { id: '05:15', titulo: '05:15' },
                            { id: '05:30', titulo: '05:30' },
                            { id: '05:45', titulo: '05:45' },
                            { id: '06:00', titulo: '06:00' },
                            { id: '06:15', titulo: '06:15' },
                            { id: '06:30', titulo: '06:30' },
                            { id: '06:45', titulo: '06:45' },
                            { id: '07:00', titulo: '07:00' },
                            { id: '07:15', titulo: '07:15' },
                            { id: '07:30', titulo: '07:30' },
                            { id: '07:45', titulo: '07:45' },
                            { id: '08:00', titulo: '08:00' },
                            { id: '08:15', titulo: '08:15' },
                            { id: '08:30', titulo: '08:30' },
                            { id: '08:45', titulo: '08:45' },
                            { id: '09:00', titulo: '09:00' },
                            { id: '09:15', titulo: '09:15' },
                            { id: '09:30', titulo: '09:30' },
                            { id: '09:45', titulo: '09:45' },
                            { id: '10:00', titulo: '10:00' },
                            { id: '10:15', titulo: '10:15' },
                            { id: '10:30', titulo: '10:30' },
                            { id: '10:45', titulo: '10:45' },
                            { id: '11:00', titulo: '11:00' },
                            { id: '11:15', titulo: '11:15' },
                            { id: '11:30', titulo: '11:30' },
                            { id: '11:45', titulo: '11:45' },
                            { id: '12:00', titulo: '12:00' },
                            { id: '12:15', titulo: '12:15' },
                            { id: '12:30', titulo: '12:30' },
                            { id: '12:45', titulo: '12:45' },
                            { id: '13:00', titulo: '13:00' },
                            { id: '13:15', titulo: '13:15' },
                            { id: '13:30', titulo: '13:30' },
                            { id: '13:45', titulo: '13:45' },
                            { id: '14:00', titulo: '14:00' },
                            { id: '14:15', titulo: '14:15' },
                            { id: '14:30', titulo: '14:30' },
                            { id: '14:45', titulo: '14:45' },
                            { id: '15:00', titulo: '15:00' },
                            { id: '15:15', titulo: '15:15' },
                            { id: '15:30', titulo: '15:30' },
                            { id: '15:45', titulo: '15:45' },
                            { id: '16:00', titulo: '16:00' },
                            { id: '16:15', titulo: '16:15' },
                            { id: '16:30', titulo: '16:30' },
                            { id: '16:45', titulo: '16:45' },
                            { id: '17:00', titulo: '17:00' },
                            { id: '17:15', titulo: '17:15' },
                            { id: '17:30', titulo: '17:30' },
                            { id: '17:45', titulo: '17:45' },
                            { id: '18:00', titulo: '18:00' },
                            { id: '18:15', titulo: '18:15' },
                            { id: '18:30', titulo: '18:30' },
                            { id: '18:45', titulo: '18:45' },
                            { id: '19:00', titulo: '19:00' },
                            { id: '19:15', titulo: '19:15' },
                            { id: '19:30', titulo: '19:30' },
                            { id: '19:45', titulo: '19:45' },
                            { id: '20:00', titulo: '20:00' },
                            { id: '20:15', titulo: '20:15' },
                            { id: '20:30', titulo: '20:30' },
                            { id: '20:45', titulo: '20:45' },
                            { id: '21:00', titulo: '21:00' },
                            { id: '21:15', titulo: '21:15' },
                            { id: '21:30', titulo: '21:30' },
                            { id: '21:45', titulo: '18:45' },
                            { id: '22:00', titulo: '22:00' },
                            { id: '22:15', titulo: '22:15' },
                            { id: '22:30', titulo: '22:30' },
                            { id: '22:45', titulo: '22:45' },
                            { id: '23:00', titulo: '23:00' },
                            { id: '23:15', titulo: '23:15' },
                            { id: '23:30', titulo: '23:30' },
                            { id: '23:45', titulo: '23:45' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name={"horaInicialAt"}
                        value={diaProjeto?.itemData.horaInicial}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "00:00";
      
                          let newPrev = JSON.parse(JSON.stringify(diaProjeto));
                          newPrev.itemData.horaInicial = v;
      
                          setDiaProjeto(newPrev);
                        }}
                      />
                    </Label>
                    <Label title="Hora Final" className="col s6 m2 l2">
                      <Select
                        isString
                        list={{
                          list: [
                            { id: '00:00', titulo: '00:00' },
                            { id: '00:15', titulo: '00:15' },
                            { id: '00:30', titulo: '00:30' },
                            { id: '00:45', titulo: '00:45' },
                            { id: '01:00', titulo: '01:00' },
                            { id: '01:15', titulo: '01:15' },
                            { id: '01:30', titulo: '01:30' },
                            { id: '01:45', titulo: '01:45' },
                            { id: '02:00', titulo: '02:00' },
                            { id: '02:15', titulo: '02:15' },
                            { id: '02:30', titulo: '02:30' },
                            { id: '02:45', titulo: '02:45' },
                            { id: '03:00', titulo: '03:00' },
                            { id: '03:15', titulo: '03:15' },
                            { id: '03:30', titulo: '03:30' },
                            { id: '03:45', titulo: '03:45' },
                            { id: '04:00', titulo: '04:00' },
                            { id: '04:15', titulo: '04:15' },
                            { id: '04:30', titulo: '04:30' },
                            { id: '04:45', titulo: '04:45' },
                            { id: '05:00', titulo: '05:00' },
                            { id: '05:15', titulo: '05:15' },
                            { id: '05:30', titulo: '05:30' },
                            { id: '05:45', titulo: '05:45' },
                            { id: '06:00', titulo: '06:00' },
                            { id: '06:15', titulo: '06:15' },
                            { id: '06:30', titulo: '06:30' },
                            { id: '06:45', titulo: '06:45' },
                            { id: '07:00', titulo: '07:00' },
                            { id: '07:15', titulo: '07:15' },
                            { id: '07:30', titulo: '07:30' },
                            { id: '07:45', titulo: '07:45' },
                            { id: '08:00', titulo: '08:00' },
                            { id: '08:15', titulo: '08:15' },
                            { id: '08:30', titulo: '08:30' },
                            { id: '08:45', titulo: '08:45' },
                            { id: '09:00', titulo: '09:00' },
                            { id: '09:15', titulo: '09:15' },
                            { id: '09:30', titulo: '09:30' },
                            { id: '09:45', titulo: '09:45' },
                            { id: '10:00', titulo: '10:00' },
                            { id: '10:15', titulo: '10:15' },
                            { id: '10:30', titulo: '10:30' },
                            { id: '10:45', titulo: '10:45' },
                            { id: '11:00', titulo: '11:00' },
                            { id: '11:15', titulo: '11:15' },
                            { id: '11:30', titulo: '11:30' },
                            { id: '11:45', titulo: '11:45' },
                            { id: '12:00', titulo: '12:00' },
                            { id: '12:15', titulo: '12:15' },
                            { id: '12:30', titulo: '12:30' },
                            { id: '12:45', titulo: '12:45' },
                            { id: '13:00', titulo: '13:00' },
                            { id: '13:15', titulo: '13:15' },
                            { id: '13:30', titulo: '13:30' },
                            { id: '13:45', titulo: '13:45' },
                            { id: '14:00', titulo: '14:00' },
                            { id: '14:15', titulo: '14:15' },
                            { id: '14:30', titulo: '14:30' },
                            { id: '14:45', titulo: '14:45' },
                            { id: '15:00', titulo: '15:00' },
                            { id: '15:15', titulo: '15:15' },
                            { id: '15:30', titulo: '15:30' },
                            { id: '15:45', titulo: '15:45' },
                            { id: '16:00', titulo: '16:00' },
                            { id: '16:15', titulo: '16:15' },
                            { id: '16:30', titulo: '16:30' },
                            { id: '16:45', titulo: '16:45' },
                            { id: '17:00', titulo: '17:00' },
                            { id: '17:15', titulo: '17:15' },
                            { id: '17:30', titulo: '17:30' },
                            { id: '17:45', titulo: '17:45' },
                            { id: '18:00', titulo: '18:00' },
                            { id: '18:15', titulo: '18:15' },
                            { id: '18:30', titulo: '18:30' },
                            { id: '18:45', titulo: '18:45' },
                            { id: '19:00', titulo: '19:00' },
                            { id: '19:15', titulo: '19:15' },
                            { id: '19:30', titulo: '19:30' },
                            { id: '19:45', titulo: '19:45' },
                            { id: '20:00', titulo: '20:00' },
                            { id: '20:15', titulo: '20:15' },
                            { id: '20:30', titulo: '20:30' },
                            { id: '20:45', titulo: '20:45' },
                            { id: '21:00', titulo: '21:00' },
                            { id: '21:15', titulo: '21:15' },
                            { id: '21:30', titulo: '21:30' },
                            { id: '21:45', titulo: '18:45' },
                            { id: '22:00', titulo: '22:00' },
                            { id: '22:15', titulo: '22:15' },
                            { id: '22:30', titulo: '22:30' },
                            { id: '22:45', titulo: '22:45' },
                            { id: '23:00', titulo: '23:00' },
                            { id: '23:15', titulo: '23:15' },
                            { id: '23:30', titulo: '23:30' },
                            { id: '23:45', titulo: '23:45' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name={"horaFinalAt"}
                        value={diaProjeto?.itemData?.horaFinal}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "00:00";
      
                          let newPrev = JSON.parse(JSON.stringify(diaProjeto));
                          newPrev.itemData.horaFinal = v;
      
                          setDiaProjeto(newPrev);
                        }}
                      />
                    </Label>
                  </div>
                </Materialize>
              </div>
              <div className="footer-modal">
                <div
                  onClick={() => {
                    setDiaProjeto(undefined);
                  }}
                >
                  <ColoredButton
                    cancelLayout
                    small
                    type="button"
                  >
                    Cancelar
                  </ColoredButton>
                </div>
                <ColoredButton
                  type="button"
                  small
                  {...{
                    background: Colors?.Color4,
                    color: Colors?.Color1,
                    hoverBackground: Colors?.Color4 + "e3",
                  }}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Salvar
                </ColoredButton>
                {
                  diaProjeto?.itemData?.id && (
                    <ColoredButton
                    type="button"
                    small
                    {...{
                      background: Colors?.Color15,
                      color: Colors?.Color1,
                      hoverBackground: Colors?.Color15 + "e3",
                    }}
                    onClick={() => {
                      handleDelSubmit();
                    }}
                  >
                    Deletar
                  </ColoredButton>
                  )
                }
              </div>
            </div>
          </div>
        )}
      </Materialize>
    </Container>
  );
}

export default CustomBodyContent;
